import { render } from "./TeamMembers.vue?vue&type=template&id=a3a5c7d8&scoped=true"
import script from "./TeamMembers.vue?vue&type=script&lang=js"
export * from "./TeamMembers.vue?vue&type=script&lang=js"

import "./TeamMembers.vue?vue&type=style&index=0&id=a3a5c7d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3a5c7d8"]])

export default __exports__